import { createFileRoute } from '@tanstack/react-router'
import GerencialPage from '../../../app/financial/gerencial/report-page'

export const Route = createFileRoute('/_auth/financial/gerencial')({
  component: GerencialPage,
})
